import Ajax from 'global/od/Ajax';

export default (data, url) => linkAccountRequest(data, url);

const linkAccountRequest = (data = {}, url) =>
	Ajax({
		url,
		method: 'POST',
		dataType: 'html',
		data,
	});
